/**
 *
 * @param hotel
 * @returns
 */

export const requireIconImg = (imgPath: string) => {
  return new URL(`../assets/icon/${imgPath}`, import.meta.url).href;
};
